/**
 * Coș doar cu proaspete, sub 250 lei: profilul General nu se activează, deci
 * transportul în București și Ilfov rămâne 0. Adăugăm automat o linie internă
 * (0 lei) din profilul General ca să se aplice tariful de 20 lei, fără dublare
 * în coș mixt. Linia e ascunsă în coș; la checkout rămâne vizibilă cu preț 0.
 */
(function () {
  'use strict';

  var LOCAL = ['B', 'IF'];
  var THRESHOLD_CENTS = 25000;
  var ZONE_KEY = 'nr_zona_livrare';
  var inflight = null;

  function anchorVariantId() {
    var id = window.__nrShipAnchorVariantId;
    return id ? String(id).trim() : '';
  }

  function isAnchorItem(item) {
    if (!item) return false;
    if (String(item.variant_id) === anchorVariantId()) return true;
    var h = (item.handle || '').toLowerCase();
    return h === 'nr-ship-anchor';
  }

  function isSgrItem(item) {
    var h = (item.handle || '').toLowerCase();
    var t = (item.product_title || item.title || '').toLowerCase();
    return h.indexOf('sgr') !== -1 || h.indexOf('garan') !== -1 || t.indexOf('garan') !== -1;
  }

  function storedZone() {
    try {
      return localStorage.getItem(ZONE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function cartMeta() {
    return fetch('/cart?view=anchor-info', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .catch(function () {
        return { fresh: 0, general: 0, total: 0, zone: '' };
      });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().catch(function () {
        return {};
      });
    });
  }

  function sync(opts) {
    opts = opts || {};
    var aid = anchorVariantId();
    if (!aid) return Promise.resolve(false);

    if (inflight) {
      return inflight.then(function () {
        return sync(opts);
      });
    }

    var changed = false;
    inflight = Promise.all([
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
        return r.json();
      }),
      cartMeta(),
    ])
      .then(function (pair) {
        var cart = pair[0];
        var meta = pair[1];
        var zone = (cart.attributes && cart.attributes['Zona de livrare']) || meta.zone || window.__nrZone || storedZone() || '';
        zone = String(zone).trim().toUpperCase();
        var outside = zone && LOCAL.indexOf(zone) === -1;
        var total = cart.total_price;
        var items = cart.items || [];
        var anchorLine = items.find(isAnchorItem);
        // Fără județ ales, adresa se scrie abia la checkout. Ancora trebuie să fie
        // deja în coș, altfel București rămâne pe tariful 0 al profilului Perisabile.
        // În afara Bucureștiului și Ilfovului nu o punem: acolo proaspetele nu pleacă.
        var needAnchor = !outside && total < THRESHOLD_CENTS && meta.fresh > 0 && meta.general === 0;

        if (needAnchor && !anchorLine) {
          return postJson((window.routes && window.routes.cart_add_url) || '/cart/add', {
            items: [{ id: aid, quantity: 1, properties: { _nr_ship_anchor: '1' } }],
          }).then(function (data) {
            if (data && data.status) return false;
            changed = true;
            return true;
          });
        }

        if (!needAnchor && anchorLine) {
          return postJson((window.routes && window.routes.cart_change_url) || '/cart/change', {
            id: anchorLine.key,
            quantity: 0,
          }).then(function () {
            changed = true;
            return true;
          });
        }

        return false;
      })
      .then(function () {
        if (changed && opts.reload !== false) window.location.reload();
        return changed;
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        inflight = null;
      });

    return inflight;
  }

  window.NrShipAnchor = { sync: sync };

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(function () {
        sync();
      }, 120);
    });
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      if (form.getAttribute('data-nr-anchor-ready') === '1') return;
      e.preventDefault();
      e.stopPropagation();
      sync({ reload: false }).finally(function () {
        form.setAttribute('data-nr-anchor-ready', '1');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter);
        else submitter.click();
      });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () {
        sync();
      }, 200);
    });
  } else {
    setTimeout(function () {
      sync();
    }, 200);
  }
})();
